import { SecondaryPagination } from "@hatch-digital-nl/abs-storybook/legacy";
import { setCurrentPage, setItemsPerPage } from "../../CertificateSlice";
import React, { JSX } from "react";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { useGetCertificatesQuery } from "../../../../common/api/certificate";
import { useEmployeeId } from "../../../../common/utils/useEmployeeId";
import Skeleton from "react-loading-skeleton";

export const EmployeeCertificatesPagination = (): JSX.Element => {
    const dispatch = useAppDispatch();

    const {
        currentPage,
        itemsPerPage,
        itemsPerPageSelect,
        activeTab,
        searchTerm,
    } = useAppSelector((state) => state.achievedQualifications);

    const { data: qualificationsData, isLoading: qualificationsDataIsLoading } =
        useGetCertificatesQuery({
            page: currentPage,
            items_per_page: itemsPerPage,
            filter: {
                status: activeTab,
                employee_id: useEmployeeId(),
                search: searchTerm,
            },
        });

    if (!qualificationsData || qualificationsDataIsLoading) {
        return <Skeleton height={"5rem"} count={1} borderRadius={"1.5rem"} />;
    }

    return (
        <div className={"p-achieved-certificates__pagination"}>
            {itemsPerPage && qualificationsData && qualificationsData.meta && (
                <SecondaryPagination
                    itemsPerPage={itemsPerPage}
                    totalItems={qualificationsData?.meta?.total || 0}
                    currentPage={currentPage}
                    onPaginationChange={(page: number) =>
                        dispatch(setCurrentPage(page))
                    }
                    totalItemsOnCurrentPage={
                        qualificationsData?.data.length || 0
                    }
                    onItemsPerPageChange={(
                        event: React.ChangeEvent<HTMLSelectElement>,
                    ) => dispatch(setItemsPerPage(Number(event.target.value)))}
                    itemsPerPageSelect={itemsPerPageSelect}
                />
            )}
        </div>
    );
};
